export const PublicationEndpoints = {
  getPost: (id: number) => `rest/v1/news/${id}/secure`,
  getPosts: (publicationId: number) => `/rest/v1/collections/${publicationId}/news`,
  getTrendingPosts: (slug: string) => `/rest/v1/membership/${slug}/posts/trending`,
  getScheduledPosts: (publicationId: number) =>
    `/rest/v1/collections/${publicationId}/news/scheduled`,
  deletePost: (id: number) => `rest/v1/news/${id}`,
  putScheduledPostsPublishNow: (postId: number) => `/rest/v1/news/${postId}/scheduled/publish`,
  getPostImage: (publicationId: number) => `/rest/v1/news/${publicationId}/secureSnapshot`,
  getPublicPostImage: (publicationId: number) => `/rest/v1/news/${publicationId}/snapshot`,
  getPostsAudio: (publicationId: number) => `/v1/communities/posts/${publicationId}/media`,
  getAuthorImage: (authorId: number) => `/rest/v1/users/${authorId}/image`,
  getMedia: (publicationId: number) => `rest/v1/news/${publicationId}/media/embed/url`,
  getStatusMedia: () => '/rest/v1/news/status',
  getLinkPreviewImage: (publicationId: number) => `/rest/v1/news/${publicationId}/secureDownload`,
  addReaction: (publicationId: number) => `/rest/v1/news/${publicationId}/reactions`,
  deleteReaction: (publicationId: number, reactionCode: string) =>
    `/rest/v1/news/${publicationId}/reactions/${reactionCode}`,
  seenReaction: () => '/rest/v1/news/reactions/seen',
  summaryReactions: (publicationId: number) =>
    `${process.env.COMMUNITY_GATEWAY_URL}/v1/posts/${publicationId}/reactions/summary`,
  banMember: (collectionId: number) => `/rest/v1/collections/${collectionId}/blockFollower`,
  readPost: (publicationId: number, accessToPost: string) =>
    `rest/v1/news/${publicationId}/read?accessedFrom=${accessToPost}`
}
